const parseInline = text => String(text)
  .split(/(\*\*[^*]+\*\*)/)
  .filter(Boolean)
  .map(part => {
    const bold = part.startsWith('**') && part.endsWith('**') && part.length > 4
    return { text: bold ? part.slice(2, -2) : part, bold }
  })

export default function parseLegalText(body) {
  const blocks = []
  let paragraph = []
  let list = null

  const flushParagraph = () => {
    if (!paragraph.length) return
    blocks.push({ type: 'paragraph', parts: parseInline(paragraph.join(' ')) })
    paragraph = []
  }
  const flushList = () => {
    if (!list) return
    blocks.push(list)
    list = null
  }
  const pushItem = (ordered, text) => {
    flushParagraph()
    if (!list || list.ordered !== ordered) {
      flushList()
      list = { type: 'list', ordered, items: [] }
    }
    list.items.push(parseInline(text))
  }

  String(body || '').replace(/\r\n/g, '\n').split('\n').forEach(raw => {
    const line = raw.trim()
    if (!line) {
      flushParagraph()
      flushList()
      return
    }
    const heading = line.match(/^(#{1,3})\s+(.+)$/)
    if (heading) {
      flushParagraph()
      flushList()
      blocks.push({ type: 'heading', level: heading[1].length + 1, parts: parseInline(heading[2]) })
      return
    }
    const bullet = line.match(/^[-*•]\s+(.+)$/)
    if (bullet) {
      pushItem(false, bullet[1])
      return
    }
    const numbered = line.match(/^\d+[.)]\s+(.+)$/)
    if (numbered) {
      pushItem(true, numbered[1])
      return
    }
    flushList()
    paragraph.push(line)
  })

  flushParagraph()
  flushList()
  return blocks
}
